
import { defineComponent, PropType } from "vue";

import { DEFAULT_LIGHT_TYPE, LightType, LightTypes } from "../utils/constants";

export default defineComponent({
  name: "TrafficSignalLight",
  props: {
    type: {
      type: String as PropType<LightType>,
      default: DEFAULT_LIGHT_TYPE
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    typeClass(): string {
      return this.type === LightTypes.RED
        ? ""
        : `traffic-signal__light_${this.type}`;
    }
  }
});
